export default {
      id: "send-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#send",
      toString: function () {
        return this.url;
      }
    }